/* ============================================================
 * GSS Postcode Gating + Regional Routing
 * Built on the original gating script by Grassick Group Media.
 *
 * Reads the zone saved by gss-finder.js (localStorage key gss_v1_zone)
 * and hides product cards/groups not available in that depot's range.
 *
 * NOTE: DEPOT_HANDLES below is a MANUAL list. It is NOT driven by
 * Shopify inventory levels or collection membership.
 *
 * REGIONAL TIER - August 2026. Extends gss-finder.js WITHOUT modifying it.
 * COVERAGE: NSW, ACT and Victoria only. Regional messaging is pickup-only
 * - we do not promise delivery, because there are many regional addresses
 * we will not deliver to. Customers who are not near a depot are pointed
 * at the dealer finder instead.
 *
 * METRO GAP FIX - the finder's metro lists are incomplete (121 of 250
 * slots in 2000-2249, none of Macarthur or Penrith/Blacktown; Melbourne
 * 191 of 211 in 3000-3210). METRO_FALLBACK_RANGES catches those before
 * regional resolution so metro customers are never priced as regional.
 * The proper fix is to complete the lists inside gss-finder.js.
 *
 * SPECIAL ORDER - August 2026. Distributors hold the medium duty
 * 2m x 2m x 0.6m unit only (source: Airtable "GSS Operations" ->
 * Distributor Catalogue, Availability field). Every other regional
 * listing carries the Shopify tag "special-order" and is labelled as
 * such on regional collection cards and regional product pages.
 * To change which products are labelled, add or remove the
 * "special-order" tag in Shopify - nothing here needs editing.
 * To change the wording, edit SPECIAL_LABEL / SPECIAL_NOTE below.
 *
 * RANGE ROUTING - August 2026. Once a regional postcode is entered, the
 * Economy / Medium Duty / Heavy Duty browse collections point at their
 * regional-priced counterparts instead of the metro ones. See CATEGORY_MAP.
 * Three mechanisms, deliberately overlapping: an early redirect before
 * first paint, a capturing click handler, and href rewriting.
 * ============================================================ */
(function () {
  'use strict';

  var KEY = 'gss_v1_zone';
  var SUFFIX = '-regional';
  var CACHE_KEY = 'gss_v1_regional_handles';
  var SPECIAL_CACHE_KEY = 'gss_v1_special_handles';
  var SPECIAL_TAG = 'special-order';
  var DEALER_URL = '/pages/find-a-dealer';
  var PIN = String.fromCodePoint(128205);

  /* ---- special order wording (edit these two lines to change copy) ---- */
  var SPECIAL_LABEL = 'Special order';
  var SPECIAL_NOTE = 'This one is a special order. Our pick up points stock the medium duty ' +
    '2m x 2m x 0.6m unit as standard, so anything else comes in on the next run. ' +
    'Order as normal and we will confirm your collection date by email.';

  var DEPOT_HANDLES = {
    wyee: null,
    brisbane: ['light-duty-steel-shelving', 'medium-duty-steel-shelving-2m'],
    melbourne: ['light-duty-steel-shelving', 'medium-duty-steel-shelving-2m'],
    adelaide: ['light-duty-steel-shelving-2m-1-85m-high-in-one-box', 'medium-duty-steel-shelving-2m-in-one-box', 'medium-duty-steel-shelving-2m'],
    perth: ['light-duty-steel-shelving-2m-1-85m-high-in-one-box', 'medium-duty-steel-shelving-2m-in-one-box', 'medium-duty-steel-shelving-1-5m', 'medium-duty-steel-shelving-2m']
  };

  var REGIONS = {
    act: { label: 'the Canberra region', url: '/collections/garage-shelving-canberra' },
    nsw: { label: 'regional NSW', url: '/collections/garage-shelving-nsw-regional' },
    vic: { label: 'regional Victoria', url: '/collections/garage-shelving-victoria-regional' }
  };

  var REGIONAL_FALLBACK = [
    'medium-duty-steel-shelving-1m-regional',
    'medium-duty-steel-shelving-1-5m-regional',
    'medium-duty-steel-shelving-2m-regional',
    'medium-duty-steel-shelving-2-4m-regional',
    'heavy-duty-steel-shelving-regional',
    'light-duty-steel-shelving-regional',
    'heavy-duty-steel-bench-regional',
    'medium-duty-workbench-regional',
    'castor-wheels-regional'
  ];

  /* Everything except medium-duty-steel-shelving-2m-regional. */
  var SPECIAL_FALLBACK = [
    'medium-duty-steel-shelving-1m-regional',
    'medium-duty-steel-shelving-1-5m-regional',
    'medium-duty-steel-shelving-2-4m-regional',
    'heavy-duty-steel-shelving-regional',
    'light-duty-steel-shelving-regional',
    'heavy-duty-steel-bench-regional',
    'medium-duty-workbench-regional',
    'castor-wheels-regional'
  ];

  /* Metro browse collection -> its regional-priced counterpart. Add
     ?gssmetro=1 to any URL to opt out and see the metro page. */
  var CATEGORY_MAP = {
    economy: 'economy-regional',
    'medium-duty': 'medium-duty-regional',
    'heavy-duty': 'heavy-duty-regional'
  };
  var RANGE_HANDLES = ['shop-the-range', 'shop-all'];
  var METRO_ESCAPE = 'gssmetro=1';

  var METRO_FALLBACK_RANGES = [
    [2000, 2249, 'Sydney'],
    [2555, 2574, 'Sydney'],
    [2745, 2770, 'Sydney'],
    [3000, 3210, 'Melbourne']
  ];

  var REMOVED = [];

  /* Runs before anything touches the DOM so a regional customer landing on a
     metro browse collection swaps over without a visible flash of metro
     pricing. Function declarations hoist, so this is safe here. */
  if (maybeRedirectToRegional()) { return; }

  /* Belt and braces: the header nav can re-render after we rewrite its hrefs,
     so catch the click itself as well. */
  document.addEventListener('click', function (e) {
    var z = load();
    if (!z || z.tier !== 'regional') { return; }
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) { return; }
    var a = (e.target && e.target.closest) ? e.target.closest('a[href*="/collections/"]') : null;
    if (!a) { return; }
    var href = a.getAttribute('href') || '';
    if (href.indexOf(METRO_ESCAPE) !== -1) { return; }
    var m = href.toLowerCase().match(/\/collections\/([a-z0-9\-]+)/);
    if (!m) { return; }
    var target = regionalCounterpart(m[1], z);
    if (!target || target === m[1]) { return; }
    e.preventDefault();
    window.location.href = href.replace('/collections/' + m[1], '/collections/' + target);
  }, true);

  /* ---------- small helpers ---------- */

  function endsWith(str, suffix) {
    return str.length >= suffix.length && str.slice(str.length - suffix.length) === suffix;
  }

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }

  function save(z) {
    try {
      localStorage.setItem(KEY, JSON.stringify(z));
      window.dispatchEvent(new Event('gss:zone-updated'));
    } catch (e) {}
  }

  function depotOf(z) {
    if (!z) { return null; }
    if (typeof z === 'string') { return z; }
    return z.depot || null;
  }

  function handleFromHref(href) {
    var path = String(href || '').toLowerCase();
    var i = path.indexOf('/products/');
    if (i === -1) { return null; }
    var rest = path.slice(i + 10);
    var cut = rest.indexOf('?');
    if (cut !== -1) { rest = rest.slice(0, cut); }
    cut = rest.indexOf('#');
    if (cut !== -1) { rest = rest.slice(0, cut); }
    cut = rest.indexOf('/');
    if (cut !== -1) { rest = rest.slice(0, cut); }
    return rest || null;
  }

  /* ---------- regional range ---------- */

  function regionalHandles() {
    if (window.GSS_REGIONAL_HANDLES && window.GSS_REGIONAL_HANDLES.length) {
      return window.GSS_REGIONAL_HANDLES;
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) {}
    window.GSS_REGIONAL_HANDLES = (cached && cached.length) ? cached : REGIONAL_FALLBACK.slice();
    return window.GSS_REGIONAL_HANDLES;
  }

  function specialHandles() {
    if (window.GSS_SPECIAL_HANDLES && window.GSS_SPECIAL_HANDLES.length) {
      return window.GSS_SPECIAL_HANDLES;
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(SPECIAL_CACHE_KEY) || 'null'); } catch (e) {}
    window.GSS_SPECIAL_HANDLES = (cached && cached.length) ? cached : SPECIAL_FALLBACK.slice();
    return window.GSS_SPECIAL_HANDLES;
  }

  function isSpecial(handle) {
    return !!handle && specialHandles().indexOf(handle) !== -1;
  }

  function hasSpecialTag(product) {
    var tags = product && product.tags;
    if (!tags) { return false; }
    if (typeof tags === 'string') {
      tags = tags.split(',');
    }
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === SPECIAL_TAG) { return true; }
    }
    return false;
  }

  function refreshRegionalHandles() {
    if (!window.fetch) { return; }
    fetch('/collections/regional-australia/products.json?limit=50', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) { return; }
        var handles = [];
        var special = [];
        for (var i = 0; i < data.products.length; i++) {
          handles.push(data.products[i].handle);
          if (hasSpecialTag(data.products[i])) { special.push(data.products[i].handle); }
        }
        window.GSS_REGIONAL_HANDLES = handles;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(handles)); } catch (e) {}
        if (special.length) {
          window.GSS_SPECIAL_HANDLES = special;
          try { sessionStorage.setItem(SPECIAL_CACHE_KEY, JSON.stringify(special)); } catch (e) {}
        }
        applyGating();
        renderTwinBanner();
        markSpecialCards();
        renderSpecialNotice();
      })
      .catch(function () {});
  }

  /* ---------- postcode resolution ---------- */

  function inMetroFallback(n) {
    for (var i = 0; i < METRO_FALLBACK_RANGES.length; i++) {
      if (n >= METRO_FALLBACK_RANGES[i][0] && n <= METRO_FALLBACK_RANGES[i][1]) {
        return METRO_FALLBACK_RANGES[i][2];
      }
    }
    return null;
  }

  function findRegion(pc) {
    var raw = String(pc || '').trim();
    if (raw.length !== 4) { return null; }
    var n = parseInt(raw, 10);
    if (!n) { return null; }
    if (n >= 2600 && n <= 2622) { return 'act'; }
    if (n >= 2900 && n <= 2920) { return 'act'; }
    if (n >= 2580 && n <= 2583) { return 'act'; }
    if (n >= 2000 && n <= 2999) { return 'nsw'; }
    if (n >= 3000 && n <= 3999) { return 'vic'; }
    return null;
  }

  /* ---------- finder result override ---------- */

  function handleFinderResult() {
    var res = document.getElementById('gssf-result');
    var input = document.getElementById('gssf-input');
    if (!res || !input) { return; }
    if (res.className.indexOf('gssf-out') === -1) { return; }

    var raw = String(input.value || '').trim();
    var n = parseInt(raw, 10);

    var metroCity = (raw.length === 4 && n) ? inMetroFallback(n) : null;
    if (metroCity) {
      var isMelbourne = metroCity === 'Melbourne';
      res.className = 'gssf-result gssf-ok';
      res.innerHTML =
        '<strong>Good news, we ' + (isMelbourne ? 'offer metro pick up or delivery in ' : 'deliver to ') + metroCity + '.</strong>' +
        '<p>You can order online with pickup or delivery at checkout.</p>' +
        '<a class="gssf-cta" href="/collections/shop-all">Shop available range</a>';
      save({
        city: metroCity,
        depot: isMelbourne ? 'melbourne' : 'wyee',
        fullRange: !isMelbourne
      });
      renderBar();
      applyGating();
      return;
    }

    var region = findRegion(raw);
    if (!region) { return; }

    var r = REGIONS[region];
    res.className = 'gssf-result gssf-ok';
    res.innerHTML =
      '<strong>Good news, we have multiple dealer pick up options across NSW, ACT and Victoria.</strong>' +
      '<p>Regional pricing includes the area charge to get your order to the depot, so the price on the page is the price you pay. Collection is free.</p>' +
      '<a class="gssf-cta" href="' + r.url + '">Shop the regional range</a>' +
      '<div class="gssf-dealer">Not near one of our depots? <a href="' + DEALER_URL + '">Find a local distributor</a>.</div>';

    save({
      city: r.label,
      depot: 'regional',
      tier: 'regional',
      region: region,
      collection: r.url,
      fullRange: false
    });
    renderBar();
    rewriteRangeLinks();
  }

  function hookFinder() {
    document.addEventListener('click', function (e) {
      if (!e.target || e.target.id !== 'gssf-go') { return; }
      setTimeout(handleFinderResult, 0);
    });
    document.addEventListener('keydown', function (e) {
      if (!e.target || e.target.id !== 'gssf-input') { return; }
      if (e.key !== 'Enter') { return; }
      setTimeout(handleFinderResult, 0);
    });
  }

  /* ---------- location bar ---------- */

  function renderBar() {
    var z = load();
    if (!z) { return; }
    var bar = document.getElementById('gssf-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'gssf-bar';
      bar.innerHTML =
        '<span class="gssf-bar-pin">' + PIN + '</span>' +
        '<span class="gssf-bar-lead"></span> ' +
        '<span class="gssf-bar-city"></span> ' +
        '<button class="gssf-bar-change" type="button">Change</button>';
      document.body.insertBefore(bar, document.body.firstChild);
      bar.querySelector('.gssf-bar-change').addEventListener('click', function () {
        var ov = document.getElementById('gssf-overlay');
        if (ov) { ov.classList.add('gssf-open'); }
      });
    }
    var lead = bar.querySelector('.gssf-bar-lead');
    var city = bar.querySelector('.gssf-bar-city');
    if (lead) {
      lead.textContent = (z.tier === 'regional') ? 'Pick up options in' : (z.fullRange ? 'Delivering to' : 'Metro pick up or delivery in');
    }
    if (city) { city.textContent = z.city || ''; }
  }

  /* ---------- wrong-tier banner on product pages ---------- */

  function productHandle() {
    return handleFromHref(window.location.pathname || '');
  }

  function injectTwinStyles() {
    if (document.getElementById('gssf-twin-style')) { return; }
    var style = document.createElement('style');
    style.id = 'gssf-twin-style';
    style.textContent =
      '#gssf-twin{display:flex;align-items:center;justify-content:center;gap:8px;' +
      'flex-wrap:wrap;box-sizing:border-box;width:100%;background:#fdf2ec;' +
      'border-bottom:1px solid #f6d8c6;padding:10px 16px;text-align:center;' +
      'font-family:Inter,system-ui,-apple-system,sans-serif;font-size:13.5px;' +
      'line-height:1.4;color:#1a2a4b;position:relative;z-index:3;}' +
      '#gssf-twin .gssf-twin-pin{color:#fe6b04;}' +
      '#gssf-twin .gssf-twin-cta{color:#fe6b04;font-weight:700;text-decoration:underline;}';
    document.head.appendChild(style);
  }

  function renderTwinBanner() {
    var old = document.getElementById('gssf-twin');
    if (old && old.parentNode) { old.parentNode.removeChild(old); }

    var z = load();
    var handle = productHandle();
    if (!z || !handle) { return; }

    var handles = regionalHandles();
    var onRegionalPage = endsWith(handle, SUFFIX);
    var isRegionalZone = z.tier === 'regional';
    var target, msg, cta;

    if (isRegionalZone && !onRegionalPage) {
      if (handles.indexOf(handle + SUFFIX) === -1) { return; }
      target = '/products/' + handle + SUFFIX;
      msg = 'You are shopping from ' + (z.city || 'a regional area') + '. This is the metro price.';
      cta = 'View the regional-priced version';
    } else if (!isRegionalZone && onRegionalPage) {
      target = '/products/' + handle.slice(0, handle.length - SUFFIX.length);
      msg = 'You are shopping from ' + (z.city || 'a metro area') + '. This listing is priced for regional pick up.';
      cta = 'View the standard version';
    } else {
      return;
    }

    injectTwinStyles();

    var banner = document.createElement('div');
    banner.id = 'gssf-twin';
    banner.innerHTML =
      '<span class="gssf-twin-pin">' + PIN + '</span>' +
      '<span class="gssf-twin-msg"></span>' +
      '<a class="gssf-twin-cta"></a>';
    banner.querySelector('.gssf-twin-msg').textContent = msg;
    var link = banner.querySelector('.gssf-twin-cta');
    link.textContent = cta;
    link.setAttribute('href', target);

    var bar = document.getElementById('gssf-bar');
    if (bar && bar.parentNode) {
      bar.parentNode.insertBefore(banner, bar.nextSibling);
      return;
    }
    document.body.insertBefore(banner, document.body.firstChild);
  }

  /* ---------- regional range routing ---------- */

  function collectionHandle() {
    var path = (window.location.pathname || '').toLowerCase();
    var i = path.indexOf('/collections/');
    if (i === -1) { return null; }
    var rest = path.slice(i + 13);
    var cut = rest.indexOf('/');
    if (cut !== -1) { rest = rest.slice(0, cut); }
    return rest || null;
  }

  function regionalCounterpart(handle, z) {
    if (!handle) { return null; }
    if (CATEGORY_MAP.hasOwnProperty(handle)) { return CATEGORY_MAP[handle]; }
    if (RANGE_HANDLES.indexOf(handle) !== -1) {
      if (z && z.collection) { return z.collection.replace('/collections/', ''); }
      return 'regional-australia';
    }
    return null;
  }

  function rewriteRangeLinks() {
    var z = load();
    if (!z || z.tier !== 'regional') { return; }
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-gss-rerouted')) { continue; }
      var href = a.getAttribute('href') || '';
      var m = href.toLowerCase().match(/\/collections\/([a-z0-9\-]+)/);
      if (!m) { continue; }
      var target = regionalCounterpart(m[1], z);
      if (!target || target === m[1]) { continue; }
      a.setAttribute('data-gss-rerouted', m[1]);
      a.setAttribute('href', href.replace('/collections/' + m[1], '/collections/' + target));
    }
  }

  function maybeRedirectToRegional() {
    var z = load();
    if (!z || z.tier !== 'regional') { return false; }
    if ((window.location.search || '').indexOf(METRO_ESCAPE) !== -1) { return false; }
    if (productHandle()) { return false; }
    var handle = collectionHandle();
    var target = regionalCounterpart(handle, z);
    if (!target || target === handle) { return false; }
    window.location.replace('/collections/' + target + (window.location.search || ''));
    return true;
  }

  /* ---------- special order labelling ---------- */

  function injectSpecialStyles() {
    if (document.getElementById('gssf-so-style')) { return; }
    var style = document.createElement('style');
    style.id = 'gssf-so-style';
    style.textContent =
      '.gssf-so-flag{display:inline-block;align-self:start;justify-self:start;width:fit-content;' +
      'max-width:calc(100% - 32px);margin:2px 16px 16px;padding:3px 8px;border-radius:3px;' +
      'background:#fdf2ec;border:1px solid #f6d8c6;color:#b8500a;font-weight:700;' +
      'font-size:11px;letter-spacing:.06em;text-transform:uppercase;line-height:1.4;' +
      'font-family:Inter,system-ui,-apple-system,sans-serif;}' +
      '#gssf-so-note{box-sizing:border-box;margin:14px 0;padding:12px 14px;border-radius:6px;' +
      'background:#fdf2ec;border:1px solid #f6d8c6;color:#1a2a4b;' +
      'font-family:Inter,system-ui,-apple-system,sans-serif;font-size:13.5px;line-height:1.5;}' +
      '#gssf-so-note .gssf-so-h{display:block;color:#b8500a;font-weight:700;font-size:11px;' +
      'letter-spacing:.06em;text-transform:uppercase;margin-bottom:4px;}';
    document.head.appendChild(style);
  }

  /* Keeps the innermost card element for a given product so a grid item and
     the product card nested inside it do not both get a badge. */
  function pushCard(out, seen, el, handle) {
    for (var k = 0; k < seen.length; k++) {
      var s = seen[k];
      if (s === el) { return; }
      if (s.contains(el)) { seen[k] = el; out[k] = { el: el, handle: handle }; return; }
      if (el.contains(s)) { return; }
    }
    seen.push(el);
    out.push({ el: el, handle: handle });
  }

  function collectCards() {
    var out = [];
    var seen = [];
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var handle = handleFromHref(links[i].getAttribute('href'));
      if (!handle) { continue; }
      var card = links[i].closest ? links[i].closest('[data-gss-handle], li, .product-card, .card, .grid__item') : null;
      if (!card) { continue; }
      pushCard(out, seen, card, handle);
    }
    return out;
  }

  function markSpecialCards() {
    if (productHandle()) { return; }
    var cards = collectCards();
    if (!cards.length) { return; }
    injectSpecialStyles();
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i].el;
      var handle = cards[i].handle;
      var existing = card.querySelector('.gssf-so-flag');
      if (!isSpecial(handle)) {
        if (existing && existing.parentNode) { existing.parentNode.removeChild(existing); }
        continue;
      }
      if (existing) { continue; }
      var flag = document.createElement('span');
      flag.className = 'gssf-so-flag';
      flag.textContent = SPECIAL_LABEL;
      card.appendChild(flag);
    }
  }

  function renderSpecialNotice() {
    var old = document.getElementById('gssf-so-note');
    if (old && old.parentNode) { old.parentNode.removeChild(old); }

    var handle = productHandle();
    if (!handle || !isSpecial(handle)) { return; }

    injectSpecialStyles();

    var note = document.createElement('div');
    note.id = 'gssf-so-note';
    var head = document.createElement('span');
    head.className = 'gssf-so-h';
    head.textContent = SPECIAL_LABEL;
    var body = document.createElement('span');
    body.textContent = SPECIAL_NOTE;
    note.appendChild(head);
    note.appendChild(body);

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && form.parentNode) {
      form.parentNode.insertBefore(note, form);
      return;
    }
    var h1 = document.querySelector('h1');
    if (h1 && h1.parentNode) {
      h1.parentNode.insertBefore(note, h1.nextSibling);
    }
  }

  /* ---------- card gating ---------- */

  function restoreAll() {
    for (var i = REMOVED.length - 1; i >= 0; i--) {
      var rec = REMOVED[i];
      if (!rec.element.isConnected && rec.parent) {
        if (rec.nextSibling && rec.nextSibling.isConnected) {
          rec.parent.insertBefore(rec.element, rec.nextSibling);
        } else {
          rec.parent.appendChild(rec.element);
        }
      }
      rec.element.removeAttribute('data-gss-hidden');
    }
    REMOVED = [];
  }

  function removeCard(card) {
    if (card.hasAttribute('data-gss-hidden')) { return; }
    card.setAttribute('data-gss-hidden', '1');
    REMOVED.push({ element: card, parent: card.parentNode, nextSibling: card.nextSibling });
    card.parentNode.removeChild(card);
  }

  function updateGroups() {
    document.querySelectorAll('[data-gss-group]').forEach(function (group) {
      var remaining = group.querySelectorAll('[data-gss-handle]');
      group.style.display = remaining.length > 0 ? '' : 'none';
    });
  }

  function showEverything() {
    restoreAll();
    document.querySelectorAll('[data-gss-group]').forEach(function (el) { el.style.display = ''; });
  }

  function applyGating() {
    var depot = depotOf(load());

    restoreAll();

    if (depot === 'regional') {
      var twins = regionalHandles();
      var cards = document.querySelectorAll('[data-gss-handle]');
      var doomed = [];
      var survivors = 0;
      var i, handle;
      for (i = 0; i < cards.length; i++) {
        handle = cards[i].getAttribute('data-gss-handle');
        if (!handle) { continue; }
        if (!endsWith(handle, SUFFIX) && twins.indexOf(handle + SUFFIX) !== -1) {
          doomed.push(cards[i]);
        } else {
          survivors++;
        }
      }
      /* Never gut a page down to nothing - a metro-only collection with no
         regional twins on it should render as-is rather than look broken. */
      if (survivors > 0) {
        for (i = 0; i < doomed.length; i++) { removeCard(doomed[i]); }
      }
      updateGroups();
      markSpecialCards();
      return;
    }

    var fullRange = !depot ||
      depot === 'wyee' ||
      !DEPOT_HANDLES.hasOwnProperty(depot) ||
      DEPOT_HANDLES[depot] === null;

    if (fullRange) {
      showEverything();
      markSpecialCards();
      return;
    }

    var allowed = DEPOT_HANDLES[depot];

    document.querySelectorAll('[data-gss-handle]').forEach(function (card) {
      var handle = card.getAttribute('data-gss-handle');
      if (allowed.indexOf(handle) === -1) { removeCard(card); }
    });

    updateGroups();
    markSpecialCards();
  }

  /* ---------- wiring ---------- */

  function onReady() {
    hookFinder();
    rewriteRangeLinks();
    applyGating();
    renderBar();
    renderTwinBanner();
    markSpecialCards();
    renderSpecialNotice();
    refreshRegionalHandles();
  }

  function onZoneUpdated() {
    rewriteRangeLinks();
    applyGating();
    renderBar();
    renderTwinBanner();
    markSpecialCards();
    renderSpecialNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('gss:zone-updated', onZoneUpdated);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { onZoneUpdated(); }
  });

  if (window.MutationObserver) {
    var debounceTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var hasAdditions = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
      if (!hasAdditions) { return; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        rewriteRangeLinks();
        applyGating();
        markSpecialCards();
      }, 50);
    });
    document.addEventListener('DOMContentLoaded', function () {
      var grid = document.querySelector('.product-grid, .gss-shopall');
      if (grid) { observer.observe(grid, { childList: true, subtree: true }); }
    });
  }
})();
